const HIDE_ALERT_BANNER = 'HIDE_ALERT_BANNER';
const SHOW_ALERT_BANNER = 'SHOW_ALERT_BANNER';

const hideAlertBanner = banner => ({
  type: HIDE_ALERT_BANNER,
  banner,
});

const showAlertBanner = banner => ({
  type: SHOW_ALERT_BANNER,
  banner,
});

export {
  HIDE_ALERT_BANNER,
  hideAlertBanner,
  SHOW_ALERT_BANNER,
  showAlertBanner,
};



// WEBPACK FOOTER //
// ./src/redux/actions/alertBanner.js